// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ydeE","field":"styles_field__3LRX6","fieldCol":"styles_fieldCol__23h2Q","diffCol":"styles_diffCol__2-szi","diff":"styles_diff__ft_vX"};